import api from './api';

export type OrganizationSelectionInfo = {
  application: {
    id: string;
    name: string;
    displayName?: string | undefined;
    branding?: unknown;
  };
  user: {
    id: string;
    name?: string | undefined;
    username?: string | undefined;
    primaryEmail?: string | undefined;
    primaryPhone?: string | undefined;
    avatar?: string | undefined;
  };
  organizations: Array<{ id: string; name: string; description?: string }>;
};

export const getOrganizationSelectionInfo = async () =>
  api.get('/api/interaction/organization-selection').json<OrganizationSelectionInfo>();

export const selectOrganization = async (organizationId: string) =>
  api
    .post('/api/interaction/organization-selection', { json: { organizationId } })
    .json<{ redirectTo: string }>();

export const cancelOrganizationSelection = async () =>
  api.post('/api/interaction/organization-selection/cancel').json<{ redirectTo: string }>();

export const switchOrganizationSelectionAccount = async () =>
  api.post('/api/interaction/organization-selection/switch-account').json<{ redirectTo: string }>();
